module.exports = __webpack_public_path__ + "img/2-profession-application.8eec3d41.webp";